import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NewFundsVerification" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay } from '@/utils/date-format'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { h, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus/es'
import { downloadData, editPageData, getListData } from '@/service/main/system'
import { modalConfig } from './config/modal.config'
import PageModal from '@/components/PageModal.vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import localCache from '@/utils/cache'


export default /*#__PURE__*/_defineComponent({
  __name: 'FundsVerification',
  setup(__props) {

initEmptyParam()
let query = {}
const route = useRoute()
const store = useStore()
const userInfo = store.state.login.userInfo

if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = { empIds }
    }
  }
  query = { ...query, createdTime: route.query.createdTime }
} else {
  query = { ...route.query }
}

const getApproveTeacher = async () => {
  let teacherList = await getListData(
    '/main/dictItem/queryByDictId/1815924002024198144',
    {}
  )
  localCache.setCache('teacherData', teacherList)
  const teacher = searchFormConfig.formItems.find(
    (item) => item.field === 'proveTeacher'
  )
  teacher!.options = teacherList.map((item: any) => {
    return { title: item.itemText, value: item.id }
  })
}
getApproveTeacher()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const pageInfo = ref({ pageNo: 1, pageSize: 10 })

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    createdTime: [toDay(), toDay()],
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    createdTime: [toDay(), toDay()],
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)
const router = useRouter()

const handleFillClick = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/fundsVerification/fill',
    query: {
      ...item
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenHeight * 0.9

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const modalTitle = ref('新增')

let fundsVerificationIds: Array<number> = []
let exploitAccounts: string
// 多选框选择事件
const handleSlectionChange = (value: any[]) => {
  fundsVerificationIds = []
  exploitAccounts = ''
  for (const row of value) {
    fundsVerificationIds.push(row.id)
    exploitAccounts += row.exploitAccount + ', '
  }
  exploitAccounts = exploitAccounts.substring(0, exploitAccounts.length - 2)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const handleBatchEditAccountBtnClick = (data: any) => {
  if (fundsVerificationIds.length == 0) {
    ElMessage({
      message: '请勾选修改的数据',
      type: 'warning'
    })
    return
  }

  defaultInfo.value = { oldExploitAccount: exploitAccounts.toString() }
  modalTitle.value = '批量修改'
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleUpdateBatchData = async (formData: any) => {
  try {
    const formData2 = ref<any>({})
    await editPageData('/main/fundsVerification/batch/update', {
      ...formData,
      ids: fundsVerificationIds
    })
    store.dispatch('system/getPageListAction', {
      pageName: 'fundsVerification',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRef.value.dialogVisible = false
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const handleDetailData = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/fundsVerification/detail',
    query: {
      ...item
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenWidth * 0.7

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const handleVerifyData = (item: any) => {
  ElMessageBox.confirm('', {
    title: '核实',
    confirmButtonText: '属实',
    cancelButtonText: '不属实',
    distinguishCancelAndClose: true
  })
    .then((action) => {
      if ('confirm' == action) {
        item.verifyResult = '1'
        let pageUrl = `/main/fundsVerification/verify/${item.id}/${item.verifyResult}`
        editPageData(pageUrl, {}).then(() => {
          refreshFunc()
        })
      }
    })
    .catch((err) => {
      if ('cancel' == err) {
        item.verifyResult = '2'
      }
      let pageUrl = `/main/fundsVerification/verify/${item.id}/${item.verifyResult}`
      editPageData(pageUrl, {}).then(() => {
        refreshFunc()
      })
    })
}

const handleRevokeData = (item: any) => {
  ElMessageBox.confirm('', {
    title: '是否撤销核实',
    confirmButtonText: '撤销',
    cancelButtonText: '不撤销',
    distinguishCancelAndClose: true
  }).then(() => {
      console.log(item.id)
      item.verifyResult = '0'
      let pageUrl = `/main/fundsVerification/verify/${item.id}/${item.verifyResult}`
      editPageData(pageUrl, {}).then(() => {
        refreshFunc()
      })
    })
}

const handleImportSuccess = (res: any) => {
  console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  }
}

const handleImportError = (res: any) => {
  console.log(res)
}

const refreshFunc = () => {
  store.dispatch('system/getPageListAction', {
    pageName: 'fundsVerification',
    queryInfo: store.state.system.queryInfo
  })
}

const handleUrl = (scope: any) => {
  const url = scope.row.url.split(',')[0]
  console.log(url)
}

const handleRecording = (url: string) => {
  ElMessageBox({
    title: '播放录音',
    message: h('audio', { src: url, controls: true })
  })
}
const showViewer = ref(false)

const handleSortChange = (value: any) => {
  let orderBy = value.prop
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const handleFinanceDownload = () => {
  const queryInfo = store.state.system.queryInfo
  const fileName = '518资金量核实财务导出.xlsx'
  downloadData(
    '/main/fundsVerification/downloadFinance',
    {
      ...queryInfo
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const previewSrcList = ref()
const handlePreview = (imgUrls: string) => {
  showViewer.value = true
  previewSrcList.value = imgUrls.split(',')
}
const closeViewer = () => {
  debugger
  showViewer.value = false
}

const formatVerifyResult = (row: any) => {
  if (!row.exploitAccount || !row.fundsDesc) {
    return '待填报'
  } else {
    return row.verifyResultDesc
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "fundsVerification",
        downFilename: "518业绩客户资金量核实情况登记表.xlsx",
        onFillBtnClick: handleFillClick,
        onBatchEditAccountBtnClick: handleBatchEditAccountBtnClick,
        onDownBtnClick: _unref(handleDownBtnClick),
        onSelectionChange: handleSlectionChange,
        onDetailClick: handleDetailData,
        onSortChange: handleSortChange,
        onVerifyClick: handleVerifyData,
        onRevokeClick: handleRevokeData,
        onImportSuccess: handleImportSuccess,
        onImportError: handleImportError,
        onFinanceDownload: handleFinanceDownload
      }, {
        proofImgUrls: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handlePreview(scope.row.proofImgUrls)),
            disabled: 
            scope.row.proofImgUrls === null || scope.row.proofImgUrls === ''
          
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        proveImgUrls: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handlePreview(scope.row.proveImgUrls)),
            disabled: 
            scope.row.proveImgUrls === null || scope.row.proveImgUrls === ''
          
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        recordingUrls: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handleRecording(scope.row.recordingUrls)),
            fit: "fill",
            disabled: 
            scope.row.recordingUrls === null || scope.row.recordingUrls === ''
          
          }, {
            default: _withCtx(() => [
              _createTextVNode("录音")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        verifyResult: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(formatVerifyResult(scope.row)), 1)
        ]),
        _: 1
      }, 8, ["contentTableConfig", "onDownBtnClick"]),
      _createVNode(PageModal, {
        ref_key: "pageModalRef",
        ref: pageModalRef,
        defaultInfo: defaultInfo.value,
        modalConfig: _unref(modalConfig),
        title: modalTitle.value,
        pageName: "fundsVerification",
        onUpdateBatchData: handleUpdateBatchData
      }, null, 8, ["defaultInfo", "modalConfig", "title"])
    ]),
    (showViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewSrcList.value,
          onClose: closeViewer,
          infinite: false
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})